export class SystemPath {
	static HOME = "/";
	static DASHBOARD = "/dashboard";
	static ACESSO_NEGADO = "/acesso-negado";
	static LAUDO = "/laudos";
	static LAUDO_VISUALIZACAO = `${SystemPath.LAUDO}/:codigoLaudo/visualizacao`;
	static LAUDO_VISUALIZACAO_PARECER_TECNICO_RURAL = `${SystemPath.LAUDO_VISUALIZACAO}/parecer-tecnico-rural`;
	static LAUDO_INICIAR = `${SystemPath.LAUDO}/iniciacao`;
}
